document.addEventListener('DOMContentLoaded', function () {
  const MOBILE_BREAKPOINT = 768;
  const TOP_OFFSET = 0;
  const HYSTERESIS = 24;
  const SIDE_PADDING = 30; // größer = mobiles Sticky-Bild kleiner
  const DESKTOP_TOP_OFFSET = 110; // Abstand oben auf Desktop

  let galleryContent = null;
  let artworkForm = null;
  let placeholder = null;
  let closeButton = null;
  let isSticky = false;
  let ticking = false;
  let refreshInterval = null;
  let stickyDismissed = false;

  function isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }

  function findElements() {
    galleryContent = document.querySelector('.tee-gallery-content');
    artworkForm = document.querySelector('#tee-artwork-form');
    return !!galleryContent;
  }

  function getVisibleMockup() {
    if (!galleryContent) return null;

    return (
      galleryContent.querySelector('.tee-slide.tee-slide--active .tee-mockup-item--loaded') ||
      galleryContent.querySelector('.tee-slide.tee-slide--active .tee-mockup') ||
      galleryContent.querySelector('.tee-slide.tee-slide--active .tee-mockup-zoomable') ||
      galleryContent.querySelector('.tee-slide.tee-slide--active .tee-zoom-normal') ||
      galleryContent.querySelector('.tee-mockup-item--loaded') ||
      galleryContent.querySelector('.tee-mockup') ||
      galleryContent
    );
  }

  function getPageTop(el) {
    const rect = el.getBoundingClientRect();
    return rect.top + window.scrollY;
  }

  function getViewportWidth() {
    return Math.max(
      document.documentElement ? document.documentElement.clientWidth : 0,
      window.innerWidth || 0
    );
  }

  function ensurePlaceholder() {
    if (!galleryContent) return;

    if (!placeholder) {
      placeholder = document.createElement('div');
      placeholder.className = 'tee-sticky-placeholder';
      placeholder.style.display = 'none';
      galleryContent.parentNode.insertBefore(placeholder, galleryContent);
    }
  }

  function ensureCloseButton() {
    if (!galleryContent || closeButton) return;

    closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = 'tee-sticky-close';
    closeButton.setAttribute('aria-label', 'Sticky Bild schließen');
    closeButton.innerHTML = '&times;';

    closeButton.addEventListener('click', function () {
      stickyDismissed = true;
      deactivateSticky();
    });

    galleryContent.appendChild(closeButton);
  }

  function getMetrics() {
    if (!findElements()) return null;

    const visibleMockup = getVisibleMockup();
    if (!visibleMockup) return null;

    const viewportWidth = getViewportWidth();
    const mockupRect = visibleMockup.getBoundingClientRect();
    const galleryRect = galleryContent.getBoundingClientRect();
    const stickyHeight = Math.ceil(mockupRect.height);
    const stickyWidth = Math.max(
      0,
      Math.min(
        Math.ceil(galleryRect.width),
        viewportWidth - (SIDE_PADDING * 2)
      )
    );
    const mockupCenterInsideGallery =
      (mockupRect.left - galleryRect.left) + (mockupRect.width / 2);
    const centerOffset = Math.round((stickyWidth / 2) - mockupCenterInsideGallery);

    const startY = isSticky && placeholder
      ? getPageTop(placeholder)
      : getPageTop(galleryContent);

    let endY = Infinity;

    if (artworkForm) {
      const formBottomY = getPageTop(artworkForm) + artworkForm.offsetHeight;
      endY = formBottomY - stickyHeight - TOP_OFFSET - 16;
    }

    return {
      stickyHeight,
      stickyWidth,
      centerOffset,
      startY,
      endY
    };
  }

  function activateSticky(metrics) {
    ensurePlaceholder();
    ensureCloseButton();

    if (!galleryContent || !placeholder || !metrics || stickyDismissed) return;

    placeholder.style.display = 'block';
    placeholder.style.height = metrics.stickyHeight + 'px';

    galleryContent.classList.add('tee-gallery-mobile-fixed');
    galleryContent.style.top = TOP_OFFSET + 'px';
    galleryContent.style.left = '50%';
    galleryContent.style.right = 'auto';
    galleryContent.style.width = metrics.stickyWidth + 'px';
    galleryContent.style.maxWidth = 'calc(100vw - ' + (SIDE_PADDING * 2) + 'px)';
    galleryContent.style.height = metrics.stickyHeight + 'px';
    galleryContent.style.overflow = 'hidden';
    galleryContent.style.transform = 'translate3d(-50%, 0, 0) translateX(' + metrics.centerOffset + 'px)';

    if (closeButton) {
      closeButton.style.display = 'flex';
    }

    isSticky = true;
  }

  function deactivateSticky() {
    if (!galleryContent) return;

    galleryContent.classList.remove('tee-gallery-mobile-fixed');
    galleryContent.style.removeProperty('top');
    galleryContent.style.removeProperty('left');
    galleryContent.style.removeProperty('right');
    galleryContent.style.removeProperty('width');
    galleryContent.style.removeProperty('max-width');
    galleryContent.style.removeProperty('height');
    galleryContent.style.removeProperty('overflow');
    galleryContent.style.removeProperty('transform');

    if (placeholder) {
      placeholder.style.display = 'none';
      placeholder.style.removeProperty('height');
    }

    if (closeButton) {
      closeButton.style.display = 'none';
    }

    isSticky = false;
  }

  function updateSticky() {
    ticking = false;

    if (!isMobile() || stickyDismissed) {
      deactivateSticky();
      return;
    }

    const metrics = getMetrics();
    if (!metrics) {
      deactivateSticky();
      return;
    }

    const scrollY = window.scrollY;

    if (!isSticky) {
      const shouldActivate =
        scrollY >= (metrics.startY - TOP_OFFSET) &&
        scrollY < metrics.endY;

      if (shouldActivate) {
        activateSticky(metrics);
      } else {
        deactivateSticky();
      }
    } else {
      const shouldDeactivate =
        scrollY < (metrics.startY - TOP_OFFSET - HYSTERESIS) ||
        scrollY >= metrics.endY;

      if (shouldDeactivate) {
        deactivateSticky();
      } else {
        activateSticky(metrics);
      }
    }
  }

  function requestUpdate() {
    if (!ticking) {
      window.requestAnimationFrame(updateSticky);
      ticking = true;
    }
  }

  function injectMobileStyles() {
    if (document.getElementById('tee-sticky-gallery-style')) return;

    const style = document.createElement('style');
    style.id = 'tee-sticky-gallery-style';
    style.innerHTML = `
      @media (max-width: 767px) {
        .tee-gallery-mobile-fixed {
          position: fixed !important;
          z-index: 50 !important;
          background: #fff !important;
          padding: 0 !important;
          margin: 0 !important;
          will-change: transform;
          box-sizing: border-box !important;
          box-shadow: 0 0 0 100vmax #fff !important;
          clip-path: inset(0 -100vmax) !important;
        }

        .tee-gallery-mobile-fixed,
        .tee-gallery-mobile-fixed .tee-gallery,
        .tee-gallery-mobile-fixed .tee-slider,
        .tee-gallery-mobile-fixed .tee-slide,
        .tee-gallery-mobile-fixed .tee-mockup-zoomable,
        .tee-gallery-mobile-fixed .tee-zoom-normal,
        .tee-gallery-mobile-fixed .tee-mockup-item,
        .tee-gallery-mobile-fixed .tee-mockup-item--loaded,
        .tee-gallery-mobile-fixed .tee-mockup {
          background: #fff !important;
        }

        .tee-gallery-mobile-fixed .tee-thumbnails,
        .tee-gallery-mobile-fixed .tee-slider__dots,
        .tee-gallery-mobile-fixed .tee-slider-dots,
        .tee-gallery-mobile-fixed .tee-slider__arrows,
        .tee-gallery-mobile-fixed .tee-slider-arrow,
        .tee-gallery-mobile-fixed .tee-slider-buttons,
        .tee-gallery-mobile-fixed .tee-prev,
        .tee-gallery-mobile-fixed .tee-next,
        .tee-gallery-mobile-fixed .swiper-pagination,
        .tee-gallery-mobile-fixed .swiper-button-next,
        .tee-gallery-mobile-fixed .swiper-button-prev {
          display: none !important;
          height: 0 !important;
          min-height: 0 !important;
          width: 0 !important;
          min-width: 0 !important;
          margin: 0 !important;
          padding: 0 !important;
          overflow: hidden !important;
          opacity: 0 !important;
          pointer-events: none !important;
        }

        .tee-gallery-mobile-fixed .tee-gallery,
        .tee-gallery-mobile-fixed .tee-slider,
        .tee-gallery-mobile-fixed .tee-slide,
        .tee-gallery-mobile-fixed .tee-mockup-zoomable,
        .tee-gallery-mobile-fixed .tee-zoom-normal,
        .tee-gallery-mobile-fixed .tee-mockup-item,
        .tee-gallery-mobile-fixed .tee-mockup-item--loaded,
        .tee-gallery-mobile-fixed .tee-mockup {
          margin-top: 0 !important;
          margin-bottom: 0 !important;
          padding-top: 0 !important;
          padding-bottom: 0 !important;
        }

        .tee-gallery-mobile-fixed .tee-slide {
          opacity: 1 !important;
        }

        .tee-sticky-close {
          display: none;
          position: absolute;
          top: 8px;
          right: 8px;
          width: 32px;
          height: 32px;
          border: 0;
          border-radius: 999px;
          background: rgba(255, 255, 255, 0.95);
          color: #111;
          font-size: 24px;
          line-height: 1;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          z-index: 9999;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
        }

        .tee-sticky-placeholder {
          display: none;
          width: 100%;
          margin: 0 !important;
          padding: 0 !important;
          border: 0 !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function injectDesktopStyles() {
    if (document.getElementById('desktop-sticky-media-style')) return;

    const style = document.createElement('style');
    style.id = 'desktop-sticky-media-style';
    style.innerHTML = `
      @media (min-width: 768px) {
        .m-main-product-media,
        .m-main-product--media {
          position: sticky;
          top: ${DESKTOP_TOP_OFFSET}px;
          align-self: flex-start;
        }

        .m-main-product__wrapper {
          overflow: visible !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  injectMobileStyles();
  injectDesktopStyles();

  let tries = 0;
  const waitForGallery = setInterval(function () {
    tries++;

    if (findElements()) {
      clearInterval(waitForGallery);

      ensureCloseButton();
      requestUpdate();

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
      window.addEventListener('orientationchange', requestUpdate);

      if (!refreshInterval) {
        refreshInterval = setInterval(function () {
          findElements();
          ensureCloseButton();
          requestUpdate();
        }, 2000);
      }
    }

    if (tries > 20) {
      clearInterval(waitForGallery);
    }
  }, 500);
});
